// extracted by mini-css-extract-plugin
module.exports = {"activeVideo":"ActiveVideo_activeVideo__1j08x","mobile":"ActiveVideo_mobile__2_pbU","videoBlock":"ActiveVideo_videoBlock__CxhYc","hide":"ActiveVideo_hide__3REMM"};